import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useLocation } from 'react-router-dom';

const InstagramAuthSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get redirect URL from the query parameter if available
    const searchParams = new URLSearchParams(location.search);
    const redirectUrl = searchParams.get('redirect_url');

    // Log what's happening
    console.log('InstagramAuthSuccess: Processing redirect with URL:', redirectUrl);

    // If redirect URL is provided, redirect there with success parameter
    if (redirectUrl) {
      try {
        // Create URL object for safer parsing
        const redirectUrlObj = new URL(redirectUrl);
        const redirectParams = new URLSearchParams(redirectUrlObj.search);

        // Add instagram_success=true to the parameters
        redirectParams.append('instagram_success', 'true');

        // Build the final URL
        const finalUrl = `${redirectUrlObj.origin}${redirectUrlObj.pathname}?${redirectParams.toString()}`;

        console.log('InstagramAuthSuccess: Redirecting to:', finalUrl);

        // Redirect after a short delay to allow the success message to be seen
        const timer = setTimeout(() => {
          window.location.href = finalUrl;
        }, 1500);

        return () => clearTimeout(timer);
      } catch (error) {
        console.error('Error parsing redirect URL:', error);

        // Fallback to simple redirect with instagram_success parameter
        const hasQueryParams = redirectUrl.includes('?');
        const fallbackUrl = `${redirectUrl}${hasQueryParams ? '&' : '?'}instagram_success=true`;

        const timer = setTimeout(() => {
          window.location.href = fallbackUrl;
        }, 1500);

        return () => clearTimeout(timer);
      }
    } else {
      console.log('InstagramAuthSuccess: No redirect URL provided');
    }
  }, [location, navigate]);

  // Return the success UI
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        p: 3,
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <CheckCircleIcon
        sx={{
          fontSize: 60,
          color: 'success.main',
          mb: 2
        }}
      />
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
        {t('showcaseManagement.instagramAuthSuccess')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {t('showcaseManagement.instagramAuthSuccessMessage')}
      </Typography>
    </Box>
  );
};

export default InstagramAuthSuccess;